import { useSelect } from 'admin';
import type { SiteMaterialList } from 'api';

import {
  AutocompleteField,
  type AutocompleteFieldProps,
  type AutocompleteOption,
} from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<AutocompleteOption>, 'options'> & {
  tradeCompanyId?: number;
  tradeSite?: number;
};

export const SiteMaterialAutocomplete = ({ tradeCompanyId, tradeSite, required = false, ...rest }: Props) => {
  const { options } = useSelect<SiteMaterialList>({
    filters: [{ field: 'site', operator: 'eq', value: tradeSite }],
    optionLabel: (item) => `${item.material_spec.title} ${item.grade.name} ${item.site.full_address}`,
    optionValue: 'id',
    queryOptions: {
      enabled: Boolean(tradeCompanyId),
    },
    resource: `/trade/v1/trade-companies/${tradeCompanyId}/site-materials/`,
  });
  return (
    <AutocompleteField
      data-testid="site-material-selector"
      options={options}
      disabled={!tradeCompanyId}
      getOptionLabel={(option) => {
        if (!option.label) {
          return '';
        }
        return option.label;
      }}
      required={required}
      {...rest}
    />
  );
};
